/**
 * 头部导航
 */
export default {
  signIn: 'Se connecter',
  signOut: 'Déconnexion',
}
